import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { openCookiePreferences } from "@/lib/consent";

export default function CookiePolicy() {
  return (
    <>
      <Seo title="Cookie Policy — SENIORCAR" noindex
        description="Cookie Policy di SENIORCAR: quali cookie usiamo (necessari, analytics, marketing) e come gestire il consenso." />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Cookie Policy" }]} /></div>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 pt-6 pb-16 sc-prose" data-testid="cookie-page">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900" style={{ fontFamily: "Outfit" }}>Cookie Policy</h1>
        <p className="text-sm text-slate-500 mt-2">Ultimo aggiornamento: giugno 2026</p>

        <p>I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell’utente, dove vengono
          memorizzati per poi essere ritrasmessi agli stessi siti alla visita successiva. Questo sito utilizza cookie e
          tecnologie simili nel rispetto del GDPR e delle Linee guida del Garante.</p>

        <h2>Categorie di cookie utilizzati</h2>
        <h3>1. Cookie necessari (sempre attivi)</h3>
        <p>Indispensabili per il corretto funzionamento e la sicurezza del sito (es. memorizzazione delle preferenze di
          consenso, gestione della navigazione). Non richiedono consenso.</p>

        <h3>2. Cookie di analisi (analytics)</h3>
        <p>Ci permettono di comprendere, in forma aggregata, come gli utenti utilizzano il sito, per migliorarne contenuti
          e prestazioni. Vengono installati solo previo tuo consenso.</p>

        <h3>3. Cookie di marketing</h3>
        <p>Utilizzati per misurare l’efficacia delle campagne e mostrare contenuti pertinenti sui canali di terze parti.
          Vengono installati solo previo tuo consenso.</p>

        <h2>Come gestire il consenso</h2>
        <p>Al primo accesso ti mostriamo un banner per accettare, rifiutare o personalizzare i cookie non necessari. Puoi
          modificare le tue scelte in qualsiasi momento:</p>
        <p>
          <button onClick={openCookiePreferences} data-testid="cookie-open-prefs"
            className="inline-flex items-center h-11 px-5 rounded-full text-white font-bold text-sm" style={{ backgroundColor: "var(--sc-emerald)" }}>
            Gestisci preferenze cookie
          </button>
        </p>
        <p>Puoi inoltre gestire o eliminare i cookie tramite le impostazioni del tuo browser. La disattivazione di alcuni
          cookie potrebbe limitare alcune funzionalità del sito.</p>

        <h2>Durata</h2>
        <p>Le preferenze di consenso vengono conservate sul tuo dispositivo. I cookie di analisi e marketing hanno durate
          variabili in base alla specifica tecnologia, generalmente non superiori a quanto previsto dalle indicazioni del
          Garante.</p>

        <h2>Titolare e contatti</h2>
        <p>FM FACTORY srl (brand SENIORCAR) - via Isaac Newton 9 - 20016 Pero Milano - VAT 11919330966 —
          <a href="mailto:info@seniorcar.it"> info@seniorcar.it</a>. Per maggiori informazioni sul trattamento dei dati
          consulta la <Link to="/privacy">Privacy Policy</Link>.</p>
      </article>
    </>
  );
}
